export default __webpack_public_path__ + "static/media/brand_redpagos.56e6ae42.svg";